import {
    AuditLog,
    AuditLogChangeType,
    ResourceType,
} from "@common/types/auditLog";
import { ACCRUAL_MATCH_AUDIT_FIELD } from "@common/schemas/domains/accrualReview/accrual-match-audit-log.schema";
import { SCHEDULE_RULE_SKIP_AUDIT_FIELD } from "@common/schemas/domains/accounting/scheduleRuleOutcome.schema";

export enum ChangeComponent {
    CATEGORY = "category",
    COUNTERPARTY = "counterparty",
    SPLIT = "split",
    ENTITY = "entity",
    ACCOUNT = "account",
    TRANSFER = "pairedTransfer",
    ACCRUAL_MATCH = "accrualMatch",
    CREATED = "created",
    MEMO = "memo",
    FIELD_REVIEW = "fieldReview",
    SCHEDULE_RULE_SKIP = "scheduleRuleSkip",
}

export function defineTransactionChangeComponent(
    log: AuditLog,
): ChangeComponent | undefined {
    if (log.resourceType === ResourceType.TRANSACTION_FIELD_REVIEW) {
        return ChangeComponent.FIELD_REVIEW;
    }
    if (log.changeType === AuditLogChangeType.CREATE) {
        return ChangeComponent.CREATED;
    }
    if (log.diff.some((d) => d.field === SCHEDULE_RULE_SKIP_AUDIT_FIELD)) {
        return ChangeComponent.SCHEDULE_RULE_SKIP;
    }
    if (log.diff.find((d) => d.field === ACCRUAL_MATCH_AUDIT_FIELD)) {
        return ChangeComponent.ACCRUAL_MATCH;
    }
    if (log.diff.find((d) => d.field === "entityId")) {
        return ChangeComponent.ENTITY;
    }
    if (log.diff.find((d) => d.field === "pairedTransferId")) {
        return ChangeComponent.TRANSFER;
    }
    if (
        log.diff.some(
            (d) =>
                d.field === "generalLedgerAccountId" ||
                d.field === "accountId" ||
                d.field === "accrualAccountId",
        )
    ) {
        return ChangeComponent.ACCOUNT;
    }
    if (log.diff.find((d) => d.field === "categoryId")) {
        return ChangeComponent.CATEGORY;
    }
    if (log.diff.find((d) => d.field === "counterpartyId")) {
        return ChangeComponent.COUNTERPARTY;
    }
    if (log.diff.find((d) => d.field === "splitParentId")) {
        return ChangeComponent.SPLIT;
    }
    if (log.diff.find((d) => d.field === "memo")) {
        return ChangeComponent.MEMO;
    }
    return undefined;
}
